<div class="dialog-crear-directorio">
  <h2 mat-dialog-title>{{ 'directorio.nombre' | translate }}</h2>
  <mat-dialog-content>
    <div class="dialog-crear-directorio">

      <form [formGroup]="directorioForm" class="contact-form" autocomplete="on">
        <div class="form-section">
          <mat-form-field appearance="outline" class="full-width" *ngIf="true">
            <mat-label>{{ `${data.node.path}` }}</mat-label>
            <input matInput formControlName="nombre" type="text">
            <mat-icon matPrefix></mat-icon>
            <mat-error *ngIf="directorioForm.get('nombre')?.errors">
              {{ `El nombre es requerido` }}
            </mat-error>
          </mat-form-field>
        </div>
      </form>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <div>
      <button mat-raised-button color="primary" (click)="onCreate()">
        {{ 'Create' }}
      </button>
      <button mat-raised-button color="primary" (click)="onCancel()">
        {{ 'Cancel' }}
      </button>
    </div>
  </mat-dialog-actions>
</div>